import Input from "components/Input";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import SendIcon from "assets/icons/send_purple.svg?react";
import moment from "moment";
import Button from "components/Button";
import CourtPortalService from "api/CourtPortalService";
import { ItemKind } from "dto/IKindItems";
import messagesService from "api/messagesService";
import { useContext } from "react";
import PackagesContext from "contexts/PackagesContext";
import { EConsigmentMode } from "dto/EConsigmentMode";
import { useNavigate } from "react-router-dom";
import IconsState from "components/IconsState";
import KeysContext from "contexts/KeysContext";
import { useTranslation } from "react-i18next";

const ReceiveModal: FC<Props> = ({ refetch, pack }) => {
  const { t } = useTranslation();
  const { keys } = useContext(KeysContext);
  const { packages, setPackages } = useContext(PackagesContext);
  const signature = pack.Case?.Signature ?? t("common.noSignature");
  const entity = pack.Sender;
  const c = pack.Case?.Title ?? t("cases.noCaseSubject");
  const client = pack.Case?.Client ?? t("cases.noClientSpecified");

  const { mutate: receiveFromCourtPortal, isLoading: isReceiving2 } =
    CourtPortalService.useReceiveDeliverance();

  const { mutate: receiveEDelivery, isLoading: isReceiving } =
    messagesService.useReceiveEDelivery();
  const { mutate: rejectEDelivery, isLoading: isRejecting } =
    messagesService.useRejectEDelivery();

  const handleClick = () => {
    if (pack.Kind === ItemKind.CourtPortalDeliverance) {
      receiveFromCourtPortal(
        {
          id: pack.Id,
        },
        {
          onSuccess: (result) => {
            if (result?.data) {
              const newPackages = [...packages];
              const toReplace = newPackages.find((x) => x.Id === pack.Id);

              if (toReplace) {
                newPackages[newPackages.indexOf(toReplace)] =
                  result?.data.Object;
                setPackages(newPackages);
              }
            }
            refetch();
          },
        }
      );
    } else if (pack.Kind === ItemKind.EDeliveryMessage) {
      receiveEDelivery(
        {
          id: pack.Id,
        },
        {
          onSuccess: (result) => {
            if (result?.data) {
              const newPackages = [...packages];
              const toReplace = newPackages.find((x) => x.Id === pack.Id);

              if (toReplace) {
                newPackages[newPackages.indexOf(toReplace)] = result?.data;
                setPackages(newPackages);
              }
            }

            refetch();
          },
        }
      );
    }
  };

  const navigate = useNavigate();

  const handleReject = () => {
    if (pack.Kind === ItemKind.EDeliveryMessage) {
      rejectEDelivery(
        {
          id: pack.Id,
        },
        {
          onSuccess: (result) => {
            if (result?.data) {
              const newPackages = [...packages];
              setPackages(newPackages.filter((x) => x.Id !== pack.Id));
            }

            navigate("/");
          },
        }
      );
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.modal}>
        <div className={styles.content}>
          <div className={styles.title}>{t("packages.parcelData")}</div>
          <div className={styles.date}>
            <div className={styles.left}>
              <SendIcon className={styles.icon} />{" "}
              {moment(pack.SendDate).format("DD.MM.YYYY HH:mm").toString()}
            </div>
            <div className={styles.right}>
              <IconsState
                msg={pack}
                onDownload={null}
                onPreview={null}
                keys={keys}
                showMetricIcon={false}
              ></IconsState>
            </div>
          </div>
          <div className={styles.form}>
            {pack?.Kind === ItemKind.EDeliveryMessage && (
              <Input
                disabled
                value={t("packages.eDelivery")}
                label={t("forms.packageType")}
                onChange={() => {}}
              />
            )}
            {pack?.Kind === ItemKind.EDeliveryMessage && (
              <Input
                disabled
                value={pack?.Id}
                label={t("packages.packageId")}
                onChange={() => {}}
              />
            )}
            <Input
              disabled
              value={entity}
              label={
                pack?.Kind === ItemKind.CourtPortalDeliverance
                  ? t("packages.leadingAuthority")
                  : t("forms.sender")
              }
              onChange={() => {}}
            />
            {pack?.Kind === ItemKind.EDeliveryMessage && (
              <Input
                disabled
                value={pack?.S1}
                label={t("forms.title")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={signature}
                label={t("packages.caseSignature")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={c}
                label={t("cases.caseSubject")}
                onChange={() => {}}
              />
            )}
            {pack?.Kind === ItemKind.CourtPortalDeliverance && (
              <Input
                disabled
                value={client}
                label={t("cases.client")}
                onChange={() => {}}
              />
            )}

            {pack?.Kind === ItemKind.EDeliveryMessage &&
              pack.ExpirationTime && (
                <Input
                  disabled
                  value={moment(pack.ExpirationTime).format(
                    "DD.MM.yyyy HH:mm:ss"
                  )}
                  label={t("packages.receiveBy")}
                  onChange={() => {}}
                />
              )}
          </div>
          <div className={styles.buttons}>
            {pack.ConsigmentMode === EConsigmentMode.Consent &&
              !isReceiving && (
                <Button
                  className={styles.redbutton}
                  text={t("common.reject")}
                  onClick={handleReject}
                  loading={isRejecting}
                />
              )}
            {!isRejecting && (
              <Button
                className={styles.button}
                text={t("packages.receive")}
                onClick={handleClick}
                loading={isReceiving || isReceiving2}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReceiveModal;
